import React from 'react';
import PropTypes from 'prop-types';
import css from './StickyActionsBar.module.scss';

const StickyActionsBar = ({children, className, top}) => {
  const inlineStyle = top != null ? {top} : undefined;
  const combinedClassName = className ? `${css.stickyBar} ${className}` : css.stickyBar;

  return (
    <div className={combinedClassName} style={inlineStyle}>
      {children}
    </div>
  );
};

StickyActionsBar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default StickyActionsBar;
